import { Injectable, Inject, PLATFORM_ID, signal, effect } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

export type ThemeMode = 'light' | 'dark' | 'system';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private readonly THEME_KEY = 'mb-theme-preference';
  private mediaQuery: MediaQueryList | null = null;

  // Signal to track current mode
  currentMode = signal<ThemeMode>('system');

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    if (isPlatformBrowser(this.platformId)) {
      this.initTheme();
    }
  }

  private initTheme() {
    const savedTheme = localStorage.getItem(this.THEME_KEY) as ThemeMode;
    if (savedTheme) {
      this.setTheme(savedTheme);
    } else {
      // Por defecto, iniciar en modo oscuro si el usuario aún no tiene preferencia guardada
      this.setTheme('dark');
    }

    // Listen for system changes if in system mode
    this.mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    this.mediaQuery.addEventListener('change', (e) => {
      if (this.currentMode() === 'system') {
        this.applyTheme(e.matches);
      }
    });
  }

  setTheme(mode: ThemeMode) {
    this.currentMode.set(mode);
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem(this.THEME_KEY, mode);

      if (mode === 'system') {
        const isDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
        this.applyTheme(isDark);
      } else {
        this.applyTheme(mode === 'dark');
      }
    }
  }

  private applyTheme(isDark: boolean) {
    const html = document.documentElement;
    if (isDark) {
      html.classList.add('dark');
    } else {
      html.classList.remove('dark');
    }
  }
}
